/* Mopaline: prevent duplicate add-to-cart submissions from rapid taps.
   The button is locked from the first tap until Shopify's /cart/add request settles (success or error). */
(function () {
  var busy = new WeakSet();
  var locked = null;
  var unlock = function () {
    if (!locked) return;
    busy.delete(locked);
    locked.removeAttribute('aria-busy');
    locked = null;
  };
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      p.then(function () { setTimeout(unlock, 150); }, function () { setTimeout(unlock, 150); });
    }
    return p;
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"]');
    if (!btn) return;
    if (btn.form && !btn.form.checkValidity()) return;
    if (busy.has(btn)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    busy.add(btn); locked = btn; btn.setAttribute('aria-busy', 'true');
    setTimeout(function () { if (locked === btn) unlock(); }, 6000); /* safety net if no request is made */
  }, true);
})();
